import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";

const CreateBreak = ({ show, handleClose, handleCreate }) => {
  const [breakData, setBreakData] = useState({
    title: "",
    duration: "",
    description: "",
    type: "Scheduled",
    status: true,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setBreakData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = () => {
    handleCreate(breakData);
    handleClose();
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Add Break</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>Break Title</Form.Label>
            <Form.Control
              type="text"
              name="title"
              value={breakData.title}
              onChange={handleChange}
              placeholder="Enter break title"
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Break Duration (In Minutes)</Form.Label>
            <Form.Control
              type="number"
              name="duration"
              value={breakData.duration}
              onChange={handleChange}
              placeholder="Enter duration in minutes"
              min="1"
              max="1440"
              step="1"
              onKeyDown={(e) => {
                if (e.key === '-' || e.key === 'e' || e.key === '+' || e.key === '.') {
                  e.preventDefault();
                }
              }}
              onPaste={(e) => {
                const pastedValue = e.clipboardData.getData('text');
                const numValue = Number(pastedValue);
                if (isNaN(numValue) || numValue <= 0 || numValue > 1440 || !Number.isInteger(numValue)) {
                  e.preventDefault();
                }
              }}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Break Description</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              name="description"
              value={breakData.description}
              onChange={handleChange}
              placeholder="Enter description (optional)"
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Break Type</Form.Label>
            <Form.Select
              name="type"
              value={breakData.type}
              onChange={handleChange}
            >
              <option value="Scheduled">Scheduled</option>
              <option value="Unscheduled">Unscheduled</option>
            </Form.Select>
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Discard Changes
        </Button>
        <Button variant="primary" onClick={handleSubmit}>
          Create Break
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CreateBreak;
